import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
} from "@mui/material";

const SendEmailDialog = ({
  isOpen,
  onClose,
  onSend,
  startDate,
  endDate,
  criteria,
  schoolName = "",
  type = "shortage",
}) => {
  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return "";

    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };
  const generateDefaultBody = () => {
    const formattedStart = formatDate(startDate);
    const formattedEnd = formatDate(endDate);

    if (type === "report") {
      return `Dear Student,

Please find below the attendance report of your ward from ${formattedStart} to ${formattedEnd}.

Regards,
${schoolName}`;
    }

    return `Dear Student,

This is to inform you that your attendance shortage between ${formattedStart} and ${formattedEnd}.
The required attendance percentage criteria is ${criteria}%.
Please contact the class teacher for further clarification.

Regards,
${schoolName}`;
  };

  const [emailBody, setEmailBody] = useState(generateDefaultBody());

  useEffect(() => {
    setEmailBody(generateDefaultBody());
  }, [startDate, endDate, criteria, schoolName, type]);

  const handleSend = () => {
    onSend(emailBody);
    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Email Body To Send</DialogTitle>

      <DialogContent>
        <TextField
          multiline
          fullWidth
          minRows={6}
          value={emailBody}
          onChange={(e) => setEmailBody(e.target.value)}
          inputProps={{ maxLength: 1000 }}
        />

        <Typography variant="body2" sx={{ mt: 1 }}>
          This action cannot be undone.
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>

        <Button
          variant="contained"
          onClick={handleSend}
          disabled={!emailBody.trim()}
        >
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SendEmailDialog;
